import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import injectSheet from 'react-jss';
import Dialog from '../Dialog';
import Typography from '../Typography';
import LinkIcon from '../icons/LinkIcon';

const getTitleElement = properties => {
  const {
    data: { title, url },
    classes,
  } = properties;
  if (url && url !== 'http://') {
    return (
      <a href={url} className={classes.link} target="_blank" rel="noopener noreferrer">
        {title}
        <LinkIcon className={classes.linkIcon} />
      </a>
    );
  }
  return title;
};

function ScheduleDialog(props) {
  const { classes, className, data, styles, ...dialogProps } = props;
  const { speaker, date, time, place, track, description } = data;
  return (
    <Dialog className={classNames(classes.dialog, className)} style={styles.text} {...dialogProps}>
      <span className={classes.track} />

      <div className={classes.info}>
        <Typography className={classes.date} paragraph>
          {date} - {time}
        </Typography>

        <Typography type="title" paragraph>
          {getTitleElement(props)}
        </Typography>

        <div>
          {speaker && <Typography type="body2">{speaker}</Typography>}
          {place && <Typography>{place}</Typography>}
          {track && <Typography>{track.title}</Typography>}
        </div>

        <Typography className={classes.description}>{description}</Typography>
      </div>
    </Dialog>
  );
}

ScheduleDialog.propTypes = {
  classes: PropTypes.object.isRequired,
  data: PropTypes.object.isRequired,
  styles: PropTypes.object.isRequired,
  className: PropTypes.string,
};

ScheduleDialog.defaultProps = {
  className: null,
};

const classes = theme => ({
  dialog: {
    display: 'flex',
  },
  info: {
    paddingLeft: theme.spacing.medium,
  },
  track: {
    backgroundColor: ({ data: { track = {} } }) => track.color || theme.palette.common.faintBlack,
    width: theme.spacing.small,
    flexShrink: 0,
  },
  description: {
    marginTop: theme.spacing.medium,
    whiteSpace: 'pre-wrap',
  },
  link: {
    color: 'inherit',
    fill: 'inherit',
    textDecoration: 'none',
    transition: `opacity ${theme.transitions.duration.shortest}ms`,
    willChange: 'opacity',
    '&:hover': {
      opacity: 0.7,
    },
  },
});

export default injectSheet(classes)(ScheduleDialog);



// WEBPACK FOOTER //
// ./src/site-render/src/ScheduleSection/ScheduleDialog.js